import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import Utils from '../../utils';
import { BreadcrumbThread, BreadcrumbThreadContainer, StyledLink } from './styles';
import RoutesUtils from '../../utils/routes';
import hashHistory from 'react-router/lib/hashHistory';
import { DriveItemListOrigin } from '../../containers/DriveItemListPage/constants';
import { fetchDriveItem } from '../../containers/DriveItemList/actions';
import { DriveItemInfoMap } from '../../containers/DriveItemList/reducer';
import DriveItemUtils from '../../utils/driveItem';
import FolderDropTarget from '../../containers/DriveItemList/FolderDropTarget';

export interface BreadcrumbsProps {
	dispatch: Dispatch<StoreState>;
	currentFolderId: number | undefined;
	galleryId: number;
	sharedDirId: number | undefined;
	archiveDirId: number | undefined;
	rootDirIdForEditMode: number | undefined;
	driveItems: DriveItemInfoMap;
	isEditMode: boolean;
	isCustomHomeLink: boolean;
}

export interface BreadcrumbsState {
	folderTree: FolderTreeItem[];
}

interface FolderTreeItem {
	id: number;
	label: string;
}

const grandParentFolderLabel = '...';

class Breadcrumbs extends React.Component<BreadcrumbsProps, BreadcrumbsState> {

	constructor(props: BreadcrumbsProps) {
		super(props);
		this.state = { folderTree: [] };
	}

	componentDidMount() {
		this.computeFolderTree(this.props);
	}

	componentWillReceiveProps(nextProps: BreadcrumbsProps) {
		this.computeFolderTree(nextProps);
	}

	render() {
		const { folderTree } = this.state;
		const isLoaded = folderTree.length > 0;

		return (
			<BreadcrumbThreadContainer className="BreadcrumbThreadContainer">
				<BreadcrumbThread>
					{!isLoaded
						? <div />
						: this.renderFolderTree()
					}
				</BreadcrumbThread>
			</BreadcrumbThreadContainer>
		);
	}

	renderFolderTree() {
		const { folderTree: stateFolderTree } = this.state;
		const { galleryId, sharedDirId, driveItems, currentFolderId, archiveDirId } = this.props;

		let folderTree = stateFolderTree;
		const isArchiveDirDescendant = DriveItemUtils.isDirDescendantOf(currentFolderId, archiveDirId, driveItems);

		if (isArchiveDirDescendant) {
			const archiveDirIndex = folderTree.findIndex(({ id }) => id === archiveDirId);
			folderTree.splice(0, archiveDirIndex);
		}

		const isInGallery = folderTree[0].id === galleryId;

		const shouldUseSharedDirTree = !isInGallery && !isArchiveDirDescendant;

		if (shouldUseSharedDirTree
			&& sharedDirId
			&& currentFolderId
			&& driveItems[sharedDirId]
			&& driveItems[currentFolderId]
		) {
			folderTree = [{
				label: DriveItemUtils.getDisplayName(driveItems[sharedDirId]),
				id: sharedDirId,
			}];
			if (sharedDirId !== currentFolderId) {
				folderTree.push({
					label: DriveItemUtils.getDisplayName(driveItems[currentFolderId]),
					id: currentFolderId,
				});
			}
		}

		if (folderTree.length > 3) {
			const removedItems = folderTree.length - 3;
			const antepenultimateId = folderTree[folderTree.length - 3].id;
			folderTree.splice(1, removedItems, { id: antepenultimateId, label: grandParentFolderLabel });
		}

		return folderTree.map(this.mapFolderTreeToElements.bind(this));
	}

	mapFolderTreeToElements(item: FolderTreeItem, index: number) {
		const { currentFolderId, galleryId, driveItems, rootDirIdForEditMode, isEditMode, isCustomHomeLink } = this.props;

		if (item.id !== currentFolderId) {
			let path = `${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, galleryId === item.id ? '' : item.id.toString())}`;
			if (isCustomHomeLink && galleryId === item.id ) {
				path = RoutesUtils.getPathHome();
			}
			const shouldAddDropTarget = isEditMode && DriveItemUtils.isDirDescendantOf(item.id, rootDirIdForEditMode, driveItems);

			return [
				(
					<StyledLink
						to={`${path}${hashHistory.getCurrentLocation().search}`}
						key={item.id}
					>
						{shouldAddDropTarget &&
							<FolderDropTarget
								folderId={item.id}
								isSmall={true}
							/>
						}
						{item.label}
					</StyledLink>
				),
				Utils.getSvgIcon('iconset_forth', { key: `chevron-${item.id}` })
			];
		}

		return <span key={item.id}>{item.label}</span>;
	}

	computeFolderTree(props: BreadcrumbsProps): void {
		const { currentFolderId } = props;
		const folderTree = this.getFolderTree(currentFolderId, props);

		this.setState({ folderTree });
	}

	getFolderTree(folderId: number | undefined, props: BreadcrumbsProps): FolderTreeItem[] {
		const { galleryId, sharedDirId, driveItems, dispatch } = props;
		const folder = folderId ? driveItems[folderId] : undefined;

		if (folderId) {
			if (folder) {
				const { id } = folder;
				const label = DriveItemUtils.getDisplayName(folder);
				const parentFolderId = DriveItemUtils.getParentFolderId(folder);

				if (label && id) {
					const isRootGallery = folderId === galleryId;
					const isRootSharedDir = sharedDirId && folderId === sharedDirId;
					const isRoot = isRootGallery || isRootSharedDir;
					const parentTree = parentFolderId && !isRoot ? this.getFolderTree(parentFolderId, props) : [];

					return [...parentTree, { label, id }];
				}
			} else {
				dispatch(fetchDriveItem(folderId));
			}
		}

		return [];
	}
}

export default Breadcrumbs;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Breadcrumbs/index.tsx